"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var React = __importStar(require("react"));
var bind_1 = __importDefault(require("classnames/bind"));
var styles = __importStar(require("./styles.modules.css"));
var button_1 = require("../button");
var container_1 = require("../container");
var react_router_dom_1 = require("react-router-dom");
var logo_1 = require("../logo");
var cx = bind_1.default.bind(styles);
var StatelessHeader = function (props) {
    var menuItems = props.menuItems, logo = props.logo;
    var activeClassName = cx({
        link: true,
        active: true,
    });
    return (React.createElement("header", { className: styles.outer },
        React.createElement(container_1.Container, null,
            React.createElement("div", { className: styles.menu },
                React.createElement("div", { className: styles.logo },
                    React.createElement(react_router_dom_1.Link, { to: "/dashboard" },
                        React.createElement(logo_1.Logo, { brand: "ribit", className: styles.home, url: logo }))),
                React.createElement("div", { className: styles.logoMobile },
                    React.createElement(react_router_dom_1.Link, { to: "/dashboard" },
                        React.createElement(logo_1.Logo, { brand: "ribitTextOnly", className: styles.home, url: logo }))),
                menuItems.map(function (menuItem, index) {
                    return (React.createElement(button_1.Button, { label: menuItem.label, action: menuItem.link, key: index, type: "text", className: styles.link, activeClassName: activeClassName }));
                }),
                React.createElement("button", { type: "button", className: styles.hamburgerMenuButton, onClick: props.onClickHamburgerMenuButton },
                    React.createElement("svg", { width: "40px", height: "40px", viewBox: "0 0 200 188", version: "1.1" },
                        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                            React.createElement("g", { className: styles.hamburgerIcon },
                                React.createElement("rect", { id: "Rectangle", x: "0", y: "0", width: "200", height: "40" }),
                                React.createElement("rect", { id: "Rectangle-Copy", x: "0", y: "74", width: "200", height: "40" }),
                                React.createElement("rect", { id: "Rectangle-Copy-2", x: "0", y: "148", width: "200", height: "40" })))))),
            React.createElement("div", { className: "".concat(styles.hamburgerMenuItems, " ").concat(!props.hamburgerMenuVisible ? styles.hamburgerMenuItemsHidden : "") }, menuItems.map(function (menuItem, index) {
                return (React.createElement("span", { key: index, onClick: props.onClickHamburgerMenuButton },
                    React.createElement(button_1.Button, { label: menuItem.label, action: menuItem.link, type: "text", className: styles.hamburgerLink })));
            })))));
};
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hamburgerMenuVisible: false,
            scrollPosition: 0,
        };
        _this.onClickHamburgerMenuButton = _this.onClickHamburgerMenuButton.bind(_this);
        return _this;
    }
    Header.prototype.onClickHamburgerMenuButton = function () {
        this.setState({
            hamburgerMenuVisible: !this.state.hamburgerMenuVisible,
        });
    };
    Header.prototype.render = function () {
        return (React.createElement(StatelessHeader, { logo: this.props.logo, onClickHamburgerMenuButton: this.onClickHamburgerMenuButton, hamburgerMenuVisible: this.state.hamburgerMenuVisible, menuItems: this.props.menuItems }));
    };
    return Header;
}(React.Component));
exports.Header = Header;
exports.default = Header;
//# sourceMappingURL=header.js.map